import { GET_DESIGNS, GET_SINGLE_DESIGN } from '@/utils/store/actionTypes'
import { serializeParameters } from '@/utils/general'

export default {
  async [GET_DESIGNS] (_, { sort, direction, latests, year, active, free_signup: freeSignup, in_stock: inStock, product_groups: productGroups, product_group_sizes: productGroupSizes, orientations }) {
    const params = serializeParameters({ sort, direction, latests, year, active, free_signup: freeSignup, in_stock: inStock, product_groups: productGroups, product_group_sizes: productGroupSizes, orientations })

    const response = await this.$axios.$get(`${process.env.API_URL}/v2/designs?${params}`, {
      headers: {
        ContentType: 'application/json',
        Accept: 'application/json'
      }
    })

    return response
  },
  async [GET_SINGLE_DESIGN] (_, { slug = 'hardy', product_group: productGroup = 'men-originals' }) {
    const params = serializeParameters({ product_group: productGroup })

    const response = await this.$axios.$get(`${process.env.API_URL}/v2/designs/${slug}?${params}`, {
      headers: {
        ContentType: 'application/json',
        Accept: 'application/json'
      }
    })

    return response
  }
}
